<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add New Client Campaign Step</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Client:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
             <ClientAutocomplete
          :key="companySearchComponentKey" 
            class="searchbox"
            :list="searchCompany"
            :searchOn="'company_or_registration_no'"
            @event-name="selectClient"
          ></ClientAutocomplete>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('steps')"
              >{{ errors.first("steps") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Steps:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="steps"
                v-model="steps.steps"
                v-validate="'required'"
                data-vv-as="Steps"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('steps')"
              >{{ errors.first("steps") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Steps Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="steps.description"
                v-validate="'required'"
                data-vv-as="Steps Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
                    <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Phase:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                  label="name"
                  name="phase"
                  :options="phase"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="steps.phase"
                                  v-validate="'required'"
                />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('phase')"
              >{{ errors.first("phase") }}</span
            >
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
              <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="allSteps"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="Steps">Steps</vs-th>
          <vs-th sort-key="Steps_description">Description</vs-th>
                    <vs-th sort-key="phase">Phase</vs-th>

        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].steps">
              {{ data[indextr].steps }}
            </vs-td>
            <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>
            <vs-td :data="data[indextr].phase">
              {{ data[indextr].phase }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleStepsManagement from "@/store/campaign-management/client-campaign-steps-management/moduleStepsManagement.js";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data() {
    return {
            phase: [{
        name: 'Setup',
        value: 'Setup'
      },{
        name: 'In Market',
        value: 'In Market'
      },{
        name: 'Wrap up',
        value: 'Wrap up'
      },{
        name: 'Onboarding',
        value: 'Onboarding'
      }],
          selected: [],

      allSteps:[],
          paginationAttr: {
      page_no: 1,
      per_page: 100
    },
      abilities: null,
    companySearchComponentKey:0,

      steps: {
        steps: null,
        description: null
      },
      clients:[],
      selected_client_id : null
    };
  },
  components: {
    "v-select": vSelect,
    moduleStepsManagement,
    ClientAutocomplete
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleStepsManagement.isRegistered) {
      self.$store.registerModule("StepsManagement", moduleStepsManagement);
      moduleStepsManagement.isRegistered = true;
    }
       if (!moduleClientsManagement.isRegistered) {
      self.$store.registerModule(
        "clientsManagement",
        moduleClientsManagement
      );
      moduleClientsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fetchAllClientCampaignSteps()
  },
  methods: {
        selectClient(){
          let self = this
      self.clients = moduleClientsManagement.state.clients.datas
      self.selected_client_id = self.clients[0].id
    
self.allSteps = self.allSteps.filter(function(item){
      return item.client_id == self.selected_client_id
})
    },
     searchCompany(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleClientsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if(result){
        this.addSteps();

        }
      });
    },
    fetchAllClientCampaignSteps() {
      this.$store
        .dispatch(
          "StepsManagement/fetchAllClientCampaignSteps",
          this.paginationAttr
        )
        .then(res => {
          this.allSteps =
            moduleStepsManagement.state.steps.datas;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
        handleSearch(searching) {
      console.log(`The Steps searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the Steps ordered: ${key} ${active}`);
    },
    addSteps() {
      this.steps.selected_client_id = this.selected_client_id
      this.$store
        .dispatch("StepsManagement/addSteps", this.steps)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Client Campaign Steps",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Client Campaign Steps",
              text: "The client campaign steps was added successfully"
            });
            this.$router.push({ path: "/campaigns/client-campaign-steps" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
